import { Injectable } from "@angular/core";
import { AbstractService } from "../../core/AbstractService";
import { LigneBudgetaireRequest } from "../../data/http/requests/lignebudgetaire.req";
import { LigneBudgetaireResponse } from "../../data/http/responses/lignebudgetaire.res";
import { HttpClient } from "@angular/common/http";
import { env } from "../../../env/env";
import { AppService } from "../../core/app.service";

@Injectable({ // Ajoutez le décorateur Injectable
    providedIn: 'root' // Rend le service disponible dans toute l'application
})
export class LigneBudgetaireService extends AbstractService<LigneBudgetaireRequest, LigneBudgetaireResponse>{
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}ligne-budget`, http, null, appService); 
    }
}